import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { ModalDatabaseComponent } from '../../modals/modal-database/modal-database.component';
import { ModalAlertComponent } from '../../modals/modal-alert/modal-alert.component';

import { DatabasesModel, Database } from './../../models/databases.model';
import { UserAuthService } from './../../services/user-auth.service';


@Component({
  selector: 'app-database',
  templateUrl: './database.component.html',
  styles: []
})
export class DatabaseComponent implements OnInit {

  //Variables
  rows: Database[];
  servidor:string;
  url:string;
  settings:any = [];
  private _databasesModel = new DatabasesModel;
  private observer;

  constructor(private modalService: NgbModal, private activateRoute: ActivatedRoute, private userService: UserAuthService) {
  }

  ngOnInit() {
    this.activateRoute.params.subscribe(params =>{
    this.servidor = params['name'];
    if(this.servidor.includes('-')){
      this.servidor = this.servidor.replace('-',' ');
      }
    if(this.observer){
        this.observer.unsubscribe();
      }
    this.rows = [];
    this.cargaDatos(this.servidor);
    });
  }

  /* Carga datos de las tablas alojadas*/
  cargaDatos(urlActual:string){
      this.observer = this._databasesModel.getDatabases(urlActual, this.observer).subscribe(val => {
        this.rows = val; // create the source
      });
  }

  openModal(){
   const modalRef = this.modalService.open(ModalDatabaseComponent);
   modalRef.componentInstance.server = this.servidor;
  }

  openModalWithValue(database : string){
    const modalRef = this.modalService.open(ModalDatabaseComponent);
    var item = this._databasesModel.searchInArray("clave",database, this.rows);
    modalRef.componentInstance.database = item;
    modalRef.componentInstance.server = this.servidor;
  }

  openModalforDelete(item:string, url: string){
    const modalRef = this.modalService.open(ModalAlertComponent);
    modalRef.componentInstance.item =  item;
    modalRef.componentInstance.url = url;
  }

  isAdministrador(){
    return this.userService.isAdministrador();
  }

  /*
    Filtrar Datos
  */
  filtrarNombre(event){
    const val = event.target.value.toLowerCase();
    var temp = this.rows;

    // filter our data
      temp = temp.filter(function(d) {
        return d.nombre.toLowerCase().indexOf(val) !== -1 || !val;
      });

      if(val !== '')
        this.rows = temp;
      else
        this.cargaDatos(this.servidor); //si se limpia el input se reabren todos los dominios
  }

}
